import { render } from "./MapScreen.vue?vue&type=template&id=18c70fa0"
import script from "./MapScreen.vue?vue&type=script&lang=js"
export * from "./MapScreen.vue?vue&type=script&lang=js"

import "./MapScreen.vue?vue&type=style&index=0&id=18c70fa0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__